import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/tmp/8dea56281a098ba/components/blog/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8dea56281a098ba/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/tmp/8dea56281a098ba/components/blog/TableOfContents.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/blog/PrevNextNav.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/client/link.js");
